import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { apiCall, fileUpload } from '../../../../common/apiconfig';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
import { regExpData } from '../../../../common/constants';
import { FileUpload } from '../../../account/fileupload/fileupload';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { color } from 'highcharts';
import FormHoc from '../../../hoc/formHoc';
import { InputField, AutoOptions } from '../../../formElements';
import { notesType } from '../../../../common/constants';
import { Dropdowns, Causality, AE_Outcome } from '../../../../common/constants';
import HekmaDatePicker from '../../../HekmaDatePicker'
import { BasicFileUpload } from '../../../../../adminapp/basicfileupload';

function TabContainer(props) {
  return (
    <Typography component="div" >
      {props.children}
    </Typography>
  );
}
let addNotesObjFields = {
  notes_title: '',
  notes_type: '',
  notes_text: '', 
}
const AddNotes = (propsobj) => {
  const [showForm, setshowForm] = useState(false);
  const [file, setFile] = useState();
  let [progress, setProgress] = useState(false);
  const [value, setValue] = React.useState(0);
  let [links, setLinks] = useState([]);
  let [docFiles, setDocFiles] = useState([])
  let [videoFiles, setVideoFiles] = useState([])
  let [docsData, setDocsData] = useState([]);
  let [videosData, setVideosData] = useState([]);
  let [urlErr, setUrlErr] = useState('')
  let [docErr, setDocErr] = useState('')
  let [videoErr, setVideoErr] = useState('')
  const query = new URLSearchParams(propsobj.location.search);
  const notes = query.get("notes") ? decodeURIComponent(query.get("notes")) : "";
  const noteId = query.get("noteId") || "";
  const noteType = query.get("noteType") ? decodeURIComponent(query.get("noteType")) : "";
  const noteTitle = query.get("title") ? decodeURIComponent(query.get("title")) : "";

  useEffect(() => {

    propsobj.UpdateFormField({ value: "", name: "notes_type" })
    propsobj.UpdateFormField({ value: "", name: "notes_text" })
    propsobj.UpdateFormField({ value: "", name: "notes_title" })
    let errorFieldsObj = {};
    let errorTextObj = {};
    for (var i in addNotesObjFields) {
      errorFieldsObj[i] = false;
      errorTextObj[i] = ""
    }
    propsobj.updateEntireErrorObj(errorFieldsObj, errorTextObj);
  }, []);
  const isEditMode = noteId !== "";

  const handleTabsChange = (event, newValue) => {
    setValue(newValue);
  };

  const hocObj = FormHoc(propsobj);
  const textProps = {
    ...hocObj,
    propsobj
  }
  const autoPropstoseverity = {
    'options': notesType,
    default: null,
    freeSolo: false,
    propsobj,
    keys: ['value']
  }
  // const onChangeFile = (files) => {
  //     console.log(files, "in")
  //     setFile(files)
  // }
  // const formSubmit = () => {
  // propsobj.history.push('/account/studyDetails/site/siteDetails/notes')
  // }
  const handleChange = (event, index) => {
    var products = links.slice() //or [...links];
    var newUris = products.map((item, i) => {
      if (i == index) {
        item[event.target.name] = event.target.value
      }
      return item
    })
    setLinks(newUris)

  }
  const addNew = () => {
    if (links.length >= 1) {
      if (links[links.length - 1].url == "") {
        setUrlErr("Enter URL")
      }
      else if (!regExpData.urlReg.test(links[links.length - 1].url)) {
        setUrlErr("Invalid URL")
      } else {
        setUrlErr('')
        var newlinks = [...links, { url: "", description: "" }]
        setLinks(newlinks)
      }
    } else {
      var newlinks = [...links, { url: "", description: "" }]
      setLinks(newlinks)
    }
  }
  const formSubmit = async (event) => {
    event.preventDefault();
    let linksArr = '';
    var linkClearErr = links.length > 0 ? false : true
    links.map(link => {
      if (link.url == "") {
        setUrlErr("Enter URL")
        linkClearErr = false
      }
      else if (regExpData.urlReg.test(link.url)) {
        setUrlErr('')
        linksArr += `{ buArea: "Notes",type:"Link", detail1: "${link.url}",detail2:${JSON.stringify(link.description)}}`;
        linkClearErr = true
      } else {
        setUrlErr("Invalid URL")
        linkClearErr = false
      }
    });
    let linkss = linksArr.replace(/}\s*{/g, '},{');
    let docss
    if (docFiles.length == docsData.length) {
      let docsArr = ''
      setDocErr('')
      docsData.map(doc => {
        docsArr += `{buArea: "Notes",type:"Document", detail1: "${doc.id}",detail2:"${doc.fileName}",detail3:"${doc.type}"}`;
      })
      docss = docsArr.replace(/}\s*{/g, '},{');
    } else {
      setDocErr("Upload docs to save")
    }
    let videoss
    if (videoFiles.length == videosData.length) {
      let videosArr = ''
      setVideoErr('')
      videosData.map(video => {
        videosArr += `{buArea: "Notes",type:"Video", detail1: "${video.id}",detail2:"${video.fileName}",detail3:"${video.type}"}`;
      })
      videoss = videosArr.replace(/}\s*{/g, '},{');
    } else {
      setVideoErr("Upload videos to save")
    }
    var files = []
    // if (linkss.length > 0) {
    files.push(linkss)
    // }
    // if (docss.length > 0) {
    files.push(docss)
    console.log(files, "filessss")
    // }
    // if (videoss.length > 0) {
    // files.push(videoss)
    // }
    let setGo = await hocObj.handleSubmit('addNoteForm', event);

    if (setGo) {
      setProgress(true);
      let form = propsobj.formValues;

      let requestBody;

      if (isEditMode) {

        requestBody = `
                mutation {
                    updateStudySiteNote(
                        noteId: "${noteId}",
                        studyId: "${form.studyId}",
                        siteId: "${form.siteId}",
                        notes: "${form.notes_text}",
                        noteType: "${form.notes_type}",
                        title: "${form.notes_title}"   
                    ) {
                        code
                        type
                        message
                        attributes
                    }
                }`;
      } else {

        requestBody = `
                mutation {
                    putStudySiteNoteWithSupport(
                        studyId: "${form.studyId}",
                        siteId: "${form.siteId}",
                        notes: "${form.notes_text}",
                        noteType: "${form.notes_type}",  
                        title: "${form.notes_title}",
                       supportDetails:[${files}]
                    ) {
                        code
                        type
                        message
                        attributes
                    }
                }`;
      }

      requestBody = JSON.stringify({ query: requestBody });
      let res = await apiCall(isEditMode ? 'updateStudySiteNote' : 'putStudySiteNoteWithSupport', requestBody, form);
      setProgress(false);

      if (res) {
        propsobj.history.push('/account/studyDetails/site/siteDetails/notes');
      } else {
        console.log('Error on response while adding note!');
      }
    }
  };
  const removeLink = (e, index) => {
    var arr = [...links]
    // if (index != 0) {
    arr.splice(index, 1);
    // }
    setLinks(arr)
    if (arr.length == 0) {
      setUrlErr('')
    }
  }
  const fileSave = async (files) => {
    if (value == 1) {
      var docsInfo = []
      for (var i = 0; i < files.length; i++) {
        let requestBody = { "filename": files[i].name }
        requestBody = JSON.stringify(requestBody);
        setProgress(true)
        let res = await fileUpload('fileupload', requestBody);
        if (res.code == 200) {
          var data = JSON.parse(res.attributes)
          var fdata = {
            id: data.Id,
            fileName: files[i].name,
            type: files[i].type
          }
          docsInfo.push(fdata)
          let blob = new Blob([files[i]]);
          const response = await fetch(data.URL, {
            method: "PUT",
            headers: {
              'Content-Type': files[i].type,
            },
            body: blob,
          });
          const status = await response.status;
          if (status == 200) {
            setProgress(false)
          }

        } else {
          alert('failed to upload')
        }
      }
      setDocsData(docsInfo)
    }
    if (value == 2) {
      var videosInfo = []
      setProgress(true)
      for (var i = 0; i < files.length; i++) {
        let requestBody = { "filename": files[i].name }
        requestBody = JSON.stringify(requestBody);
        setProgress(true)
        let res = await fileUpload('fileupload', requestBody);
        if (res.code == 200) {
          var data = JSON.parse(res.attributes)
          var vdata = {
            id: data.Id,
            fileName: files[i].name,
            type: files[i].type
          }
          videosInfo.push(vdata)
          let blob = new Blob([files[i]]);
          const response = await fetch(data.URL, {
            method: "PUT",
            headers: {
              'Content-Type': files[i].type,
            },
            body: blob,
          });
          const status = await response.status;
          if (status == 200) {
            setProgress(false)
          }
        } else {
          alert('failed to upload')
        }
      }
      setVideosData(videosInfo)
    }

  }
  const onChangeFile = (files) => {
    var filteredArray = [];
    var existingdata = (value == 1) ? docFiles : videoFiles
    if (files.length) {
      for (var index = 0; index < files.length; index++) {
        let exists = false;
        for (var i = 0; i < existingdata.length; i++) {
          if (existingdata[i].name === files[index].name) {
            exists = true;
            break;
          }
        }
        if (!exists) {
          filteredArray.push(files[index]);
        }
      }
    }
    var data = filteredArray.map(file => Object.assign(file, {
      preview: URL.createObjectURL(file)
    }))
    if (value == 1) {
      setDocFiles([...docFiles, ...data])
    }
    if (value == 2) {
      setVideoFiles([...videoFiles, ...data])
    }
  }
  const removeFile = (e, name) => {
    if (value == 1) {
      var filesData = [...docFiles]
      docFiles.map(file => (file.name === name && filesData.splice(filesData.indexOf(file), 1)))
      var newDocsData = [...docsData]
      docsData.map(file => (file.fileName === name && newDocsData.splice(newDocsData.indexOf(file), 1)))
      setDocFiles(filesData)
      setDocsData(newDocsData)
      //console.log(filesData, newDocsData, "filesData")
    }
    if (value == 2) {
      var filesData = [...videoFiles]
      videoFiles.map(file => (file.name === name && filesData.splice(filesData.indexOf(file), 1)))
      setVideoFiles(filesData)
      var newVideosData = [...videosData]
      videosData.map(file => (file.fileName === name && newVideosData.splice(newVideosData.indexOf(file), 1)))
      setVideosData(newVideosData)
    }
  }
  const goBack = (event) => {
    event.preventDefault();
    propsobj.history.goBack()
  }
  return (
    <>
    <div className="d-flex flex-column">
      <form noValidate autoComplete="off" id="addNoteForm" className="row" onSubmit={formSubmit}>
        <div className="col-md-6">
          <div className="row">
            <div className="col-md-12">
              <div className="panel-primary-wrap">
                <p style={{ fontSize: '25px', fontWeight: '500' }}>Notes</p>
                <div className="card">
                  <div className="card-body">
                    <div className="inputBox">
                      <div className='row'>
                        <div className="col-md-6">
                          <InputField {...textProps} name="notes_title" label="Title" must={'true'} type="text" />
                        </div>
                        <div className="col-md-6">
                          <AutoOptions {...autoPropstoseverity} name="notes_type" label="Type of Notes" keyName='value' must={'true'} />
                        </div>
                        {/* <div className="col-md-6">
                                                    <HekmaDatePicker name="AE_startDate" label={"Date"} must={'true'} minDate={new Date()} />
                                                </div> */}
                      </div>
                      <InputField {...textProps} multiline={true} variant="outlined" rows={3} rowsMax={3} name="notes_text" placeholder="text message goes here..." must={'true'} type="text" />
                      {/* <BasicFileUpload dataToAccept='image/*,.pdf,.xlsx,.txt,.xls,.ppt,.pptx,.doc,.docx' onChangeFile={onChangeFile} /> */}
                    </div>
                    {/* <div className="buttonContainer">
                                            <button className="btn btn-primary-grey btn-rounded btn-small" type="button" onClick={goBack}>CANCEL</button>
                                            <button type="submit" className="btn btn-primary-blue btn-rounded btn-small mr-1" > {isEditMode ? "EDIT" : "CREATE"}</button>
                                        </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12">

          <div className="panel-primary-wrap">
            <div className="card">
              <div className="card-body">
                <div className="card-page-header">FILES</div>
                <div className="inputBox">
                  <Tabs
                    value={value}
                    onChange={handleTabsChange}
                    indicatorColor="primary"
                    textColor="primary"

                  >
                    <Tab label="Links" />
                    <Tab label="Documents" />
                    {/* <Tab label="Videos" /> */}
                    <div style={{ display: "inline-flex" }}>
                      <div className="errMsg">{urlErr}</div>
                      <div className="errMsg">{docErr}</div>
                      <div className="errMsg">{videoErr}</div>
                    </div>
                    {value === 0 &&
                      <div className="" >
                        <button onClick={addNew} type="button" className="btn btn-primary-blue btn-rounded" style={{ width: "92%" ,margin:'10px'}}>
                          <i className="fa fa-plus-circle mr-1 "></i> Add New Url</button>
                      </div>
                    }
                  </Tabs>
                  {value === 0 && <TabContainer>

                    <>
                      <div className="row">
                        {
                          links.length > 0 &&
                          <div className="col-md-12">

                            <div className="table-responsive-md">
                              <table className="table table_courses">
                                <thead className="thead_color">
                                  <tr>
                                    <td>
                                      S.NO
                                    </td>
                                    <td>Link/URL</td>
                                    <td>Description</td>
                                    <td>Actions</td>
                                  </tr>
                                </thead>
                                <tbody>

                                  {
                                    links.map((item, i) => {
                                      return (
                                        <tr>
                                          <td>{i + 1}</td>
                                          <td>
                                            <TextField
                                              value={links[i].url}
                                              // label="Add URL"
                                              type="text"
                                              name="url"
                                              onChange={(e) => handleChange(e, i)}
                                              style={{ width: "100%" }}
                                            />
                                          </td>
                                          <td>
                                            <TextField
                                              multiline={true}
                                              rows={1}
                                              rowsMax={3}
                                              value={links[i].description}
                                              // label="Description"
                                              type="text"
                                              name="description"
                                              onChange={(e) => handleChange(e, i)}
                                              style={{ width: "100%" }}
                                            />

                                          </td>
                                          <td className="td_action">
                                            {/* <div className="action_div"  >
<Tooltip title="Submit"><Icon color="primary" onSubmit={(e) => onSubmit(e, i)}
>check_circle</Icon></Tooltip>
</div> */}
                                            {/* {i >= 0 && */}
                                            <div className="action_div"  >
                                              <Tooltip title="Remove"><Icon color="error" onClick={(e) => removeLink(e, i)} > remove_circle</Icon></Tooltip>
                                            </div>
                                            {/* } */}
                                            {/* {links.length == i + 1 && ( */}

                                            {/* )} */}

                                          </td>
                                        </tr>
                                      )
                                    })
                                  }
                                </tbody>
                              </table>

                            </div>
                          </div>
                        }

                        <div className="col-md-2">

                        </div>
                      </div>
                      {/* <div className="errMsg">{urlErr}</div> */}


                    </>


                  </TabContainer>}
                  {value === 1 && <TabContainer>
                    <FileUpload dataToAccept='image/*,.pdf,.xlsx,.txt,.xls,.ppt,.pptx,.doc,.docx' fileSave={fileSave} onChangeFile={onChangeFile} allFiles={docFiles} removeFile={removeFile} disabled={docFiles.length == docsData.length} /> <br /> </TabContainer>}
                  {/* {value === 2 && <TabContainer>
                    <FileUpload dataToAccept='video/*' fileSave={fileSave} onChangeFile={onChangeFile} allFiles={videoFiles} removeFile={removeFile} disabled={videoFiles.length == videosData.length} /><br />
                    <VideoUpload/>
                    <div className="errMsg">{videoErr}</div>
                </TabContainer>} */}

                </div>
              </div>
            </div>
          </div>
          <div className="buttonContainer mb-3">
            <button className="btn btn-primary-grey btn-rounded btn-small" type="button" onClick={goBack}>CANCEL</button>
            <button type="submit" className="btn btn-primary-blue btn-rounded btn-small mr-1" > {isEditMode ? "EDIT" : "CREATE"}</button>
          </div>
        </div>
      </form>
    </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    formValues: state.form,
    state
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateFormField: (obj) => {
      return dispatch(
        {
          type: 'UpdateFormField',
          value: obj.value,
          name: obj.name
        }
      )
    },
    clearForm: () => {
      return dispatch(
        {
          type: 'ClearForm',
        }
      )
    },
    updateErrorObj: (obj) => {
      return dispatch(
        {
          type: 'updateErrorObj',
          flag: obj.flag,
          name: obj.name,
          text: obj.text
        }
      )
    },
    updateEntireErrorObj: (errobj, errtextobj) => {
      return dispatch(
        {
          type: 'updateEntireErrorObj',
          errobj: errobj,
          errtextobj: errtextobj,
        }
      )
    },
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddNotes));